import Marionette from "backbone.marionette";
import templates from "../../utils/templates";

const DEFAULTS = {
  className: "alert",
  attributes: {
    role: "alert",
  },
  template: templates.find("generic", "alert"),
};

class View extends Marionette.ItemView {
  constructor(options = {}) {
    _.defaults(options, DEFAULTS);
    super(options);
  }

  onBeforeRender() {
    this.$el.addClass(`alert-${this.model.getType()}`);
  }
}

export { View as default };
